import type { Control, ControlOption } from '../../gen/openapi';

export type { Control, ControlOption };

/** Selected control values keyed by `Control.key` (mirrors the backend `ControlSelections`). */
export type ControlSelections = Record<string, string[]>;

/**
 * The dimension whose values are the caller's instances. A control on this dimension is
 * the instance picker: applying its selection also re-scopes the analytics chat (URL).
 * Kept in sync with the backend `INSTANCE_DIMENSION`.
 */
export const INSTANCE_DIMENSION = 'install_base_id';
export const CUSTOMER_DIMENSION = 'account';
export const SCOPE_DIMENSIONS: readonly string[] = [CUSTOMER_DIMENSION, INSTANCE_DIMENSION];
